import React from 'react';
import { Button, Checkbox, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  initFilter,
  quickCompareFilter,
  toggleCompareRule,
  toggleRule,
} from '@store/trends/base/actions';
import { modeAtom, TABLE_MODES } from '../atoms';
import {
  compareRuleSetSelector,
  quickCompareRuleSetSelector,
  ruleSetSelector,
} from '@store/trends/base/selectors';
import { useAtomValue } from 'jotai';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { filterColors } from '@utils';
import { ActionCellWrapper } from './styled';
import apptracker from '@utils/sensor/apptracker';
import { QUICK_COMPARE } from '@src/utils/sensor/track';

const getRowId = (rowData, dimension) => {
  if (rowData && rowData.value) {
    return `${dimension}-${rowData.value.join('')}`;
  }
};

function ActionCell({ column, rowData }) {
  const dispatch = useDispatch();
  const mode = useAtomValue(modeAtom);

  const activeRuleSet = useSelector(ruleSetSelector);
  const allRuleSet: any = useSelector(compareRuleSetSelector);
  const quickCompareRuleSet: any = useSelector(quickCompareRuleSetSelector);

  const { dimension } = column;

  const handleClick = () => {
    if (!rowData.disableDrilldown) {
      switch (mode) {
        case TABLE_MODES.filter: {
          dispatch(toggleRule(dimension, rowData));
          break;
        }
        case TABLE_MODES.compare: {
          // create empty filter if this is the first rule action
          if (activeRuleSet.size === 0) {
            dispatch(initFilter({ dimension, row: rowData }));
          } else {
            dispatch(toggleCompareRule(dimension, rowData));
          }
          break;
        }
      }
    }
  };

  const handleQuickCompare = () => {
    dispatch(quickCompareFilter(dimension, rowData));
    apptracker(QUICK_COMPARE, { dimension });
  }

  const handleAddCompare = () => {
    dispatch(initFilter({ dimension, row: rowData }));
  };

  const styles: any = rowData.disableDrilldown ? { pointerEvents: 'none' } : {};
  const rowId: any = getRowId(rowData, dimension);

  // for cell border coloring
  if (rowId in allRuleSet) {
    styles.borderColor = filterColors[allRuleSet[rowId]];
  }

  return (
    <ActionCellWrapper style={styles}>
      {!rowData.disableDrilldown &&
        ([TABLE_MODES.filter, TABLE_MODES.compare].includes(mode) ? (
          <Space size={2}>
            <Checkbox checked={activeRuleSet.has(rowId)} onClick={handleClick} />
            {mode === TABLE_MODES.compare && (
              <Button type="text" icon={<PlusOutlined />} onClick={handleAddCompare} />
            )}
          </Space>
        ) : (
          <Space size={2}>
            <Button
              type="text"
              icon={rowId in quickCompareRuleSet ? <MinusOutlined /> : <PlusOutlined />}
              onClick={handleQuickCompare}
            />
          </Space>
        ))}
    </ActionCellWrapper>
  );
}

export default ActionCell;
